import { IQueryParams } from 'src/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { merchantGroupsApi } from './requestHandlers';

const getMany = createAsyncThunk('merchantGroups/getMany', async ({ page, size, ...data }: IQueryParams) => {
  return await merchantGroupsApi.getMany({ page, size, ...data });
});

const getDetailsById = createAsyncThunk('merchantGroups/getDetailsById', async (id: number) => {
  return await merchantGroupsApi.getMany({ integrationMerchantAccountGroupIds: [id] });
});

export const merchantGroupsActions = {
  getMany,
  getDetailsById,
};
